import { useEffect, useRef, type ReactNode } from 'react';
import { router } from '@inertiajs/react';
import { trackPage } from '../utils/analytics';
import { trackMetaPageView } from '../utils/metaPixel';
import { setupAnalyticsWithConsent } from '../utils/consent';

type AnalyticsAppProps = {
  children: ReactNode;
};

const AnalyticsApp = ({ children }: AnalyticsAppProps) => {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    // Initialise GA + Meta via Axeptio (consent)
    setupAnalyticsWithConsent();

    // Track page view Google
    trackPage(window.location.pathname, document.title);

    // Track page view Meta
    trackMetaPageView();

    const removeListener = router.on('navigate', (event) => {

      // Analytics Google
      trackPage(event.detail.page.url, document.title);

      // Analytics Meta
      trackMetaPageView();
    });

    return () => removeListener();
  }, []);

  return <>{children}</>;
};

export default AnalyticsApp;
